import React, { useState, useEffect } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//paparse
import { parse} from "papaparse";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

async function getData(url) {
     const data = parse(await fetchCsv(url), { header: true });
     return data.data;
}

async function fetchCsv(url) {
    const response = await fetch(url);
    const reader = response.body.getReader();
    const result = await reader.read();
    const decoder = new TextDecoder('utf-8');
    const csv = await decoder.decode(result.value);
    return csv;
}

export default function Ecuador({ survey }) {
    //language
    const { language } = useCurrentLanguage();

    //useState - data
    const [data, setData] = useState([]);

    //useState - questions
    const [questions, setQuestions] = useState([]);

    //useEffect
    useEffect(() => {
        if(survey !== '') handleGetData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey]);

    //handle get data
    const handleGetData = async () => {
        const csv1 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q1.csv`);
        const csv2 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q2.csv`);
        const csv3 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q3.csv`);
        const csv4 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q4.csv`);
        const csv5 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q5.csv`);
        const csv6 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q6.csv`);
        const csv7 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q7.csv`);
        const csv8 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q8.csv`);
        const csv9 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}ecuador_q9.csv`);

        //q1-q3
        let data1 = [csv1.map((e) => e['categoria']), csv1.map((e) => Number(e['Porcentaje']))];
        let data2 = [csv2.map((e) => e['categoria']), csv2.map((e) => Number(e['Porcentaje']))];
        let data3 = [csv3.map((e) => e['categoria']), csv3.map((e) => Number(e['Porcentaje']))];
        

        //q4
        /* const y_data4 = csv4.map((e) => e['Respuesta']);
        const x_data4 = Object.keys(csv4[0]).filter((e) => e !== 'Respuesta')
        let data4 = [x_data4, y_data4, [y_data4.map((e, i) => Number(csv4[i][x_data4[0]])), y_data4.map((e, i) => Number(csv4[i][x_data4[1]]), y_data4.map((e, i) => Number(csv4[i][x_data4[2]])))]] */
        let data4 = [csv4.map((e) => e['categoria']), csv4.map((e) => Number(e['Porcentaje']))];

        //q5
        let data5 = [csv5.map((e) => e['Respuesta']), csv3.map((e) => Number(e['Porcentaje']))];

        //q6
        let data6 = csv6.map((e) => ({value: Number(e['Porcentaje']), name: e['categoria']}))

        //q7
        let data7 = [csv7.map((e) => e['Respuesta']), csv7.map((e) => Number(e['Porcentaje']))];

        //q8
        let data8 = csv8.map((e) => ({value: Number(e['Porcentaje']), name: e['categoria']}))

        //q9
        let data9 = [csv9.map((e) => e['categoria']), csv9.map((e) => Number(e['Porcentaje']))];
          
        let temp = [
            {
                id: "q1",
                question: TEXT['ECU']['q1']['question'][language],
                source: TEXT['ECU']['q1']['source'][language],
                description: TEXT['ECU']['q1']['description'][language],
                data: data1,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q1']['survey'][language],
                link: TEXT['ECU']['q1']['link']
            },
            {
                id: "q2",
                question: TEXT['ECU']['q2']['question'][language],
                source: TEXT['ECU']['q2']['source'][language],
                description: TEXT['ECU']['q2']['description'][language],
                data: data2,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q2']['survey'][language],
                link: TEXT['ECU']['q2']['link']
            },
            {
                id: "q3",
                question: TEXT['ECU']['q3']['question'][language],
                source: TEXT['ECU']['q3']['source'][language],
                description: TEXT['ECU']['q3']['description'][language],
                data: data3,
                graphType: "h_bar",
                rotate: true,
                marginBottom: '20px',
                hasOptions: false,
                survey: TEXT['ECU']['q3']['survey'][language],
                link: TEXT['ECU']['q3']['link'],
            },
            {
                id: "q4",
                question: TEXT['ECU']['q4']['question'][language],
                source: TEXT['ECU']['q4']['source'][language],
                description: TEXT['ECU']['q4']['description'][language],
                data: data4,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q4']['survey'][language],
                link: TEXT['ECU']['q4']['link'],
                barLegend: language === 'es' ? "De acuerdo" : "Agree",
            },
            {
                id: "q5",
                question: TEXT['ECU']['q5']['question'][language],
                source: TEXT['ECU']['q5']['source'][language],
                description: TEXT['ECU']['q5']['description'][language],
                data: data5,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q5']['survey'][language],
                link: TEXT['ECU']['q5']['link'],
                marginBottom: 80,
                barLegend: language === 'es' ? "De acuerdo" : "Agree",
            },
            {
                id: "q6",
                question: TEXT['ECU']['q6']['question'][language],
                source: TEXT['ECU']['q6']['source'][language],
                description: TEXT['ECU']['q6']['description'][language],
                data: data6,
                graphType: "pie",
                hasOptions: false,
                survey: TEXT['ECU']['q6']['survey'][language],
                link: TEXT['ECU']['q6']['link']
            },
            {
                id: "q7",
                question: TEXT['ECU']['q7']['question'][language],
                source: TEXT['ECU']['q7']['source'][language],
                description: TEXT['ECU']['q7']['description'][language],
                data: data7,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q7']['survey'][language],
                link: TEXT['ECU']['q7']['link'],
                barLegend: language === 'es' ? "Correcto" : "Right"
            },
            {
                id: "q8",
                question: TEXT['ECU']['q8']['question'][language],
                source: TEXT['ECU']['q8']['source'][language],
                description: TEXT['ECU']['q8']['description'][language],
                data: data8,
                graphType: "pie",
                hasOptions: false,
                survey: TEXT['ECU']['q8']['survey'][language],
                link: TEXT['ECU']['q8']['link']
            },
            {
                id: "q9",
                question: TEXT['ECU']['q9']['question'][language],
                source: TEXT['ECU']['q9']['source'][language],
                description: TEXT['ECU']['q9']['description'][language],
                data: data9,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['ECU']['q9']['survey'][language],
                link: TEXT['ECU']['q9']['link']
            },
        ]
        let tempQ = []
        temp.forEach((e) => {
            if(e.survey === survey) tempQ.push({code: e.id, label: e.question})
        })
        console.log(temp)
        setData(temp.filter((el) => el.survey === survey))
        setQuestions(tempQ);
     }

     return (
       <div>
          <SurveyNational data={data} questions={questions} title={survey}/>
       </div>
  );
}
